// extraTools.js — single resolver for the agentLoop `extraTools` seam. Combines the
// hermes-harvest server tools (memory / session_search, gated by their Worker flags)
// with the gated computer_use tool (agent-computer-use E3). Keeps SessionWorkspace's
// wire to one call and one import; each sub-resolver returns [] when its feature is
// off, so OFF ⇒ byte-identical tool set.

import { resolveHarvestTools } from './harvestTools.js';
import { resolveComputerUseTools } from './computerUseTool.js';
import { resolveWatchVideoTools } from './watchVideoTool.js';
import { resolveWebFetchTools } from './webFetchTool.js';
import { resolveLoadSkillTools } from './loadSkillTool.js';
import { resolveMcpConnectorTools } from './mcpConnectorTools.js';
import { resolveGoogleTools } from './googleTool.js';
import { resolveGithubTools } from './githubTool.js';

export async function resolveExtraTools() {
  return [
    ...(await resolveHarvestTools()),
    ...resolveComputerUseTools(),
    ...resolveWatchVideoTools(),
    // WSX (forense Pro Esporte) — web em TODA sessão local (chat E code). Reverte #431:
    // o agente do Code precisava buscar páginas (SEO ao vivo) e sem web caía em curl|python3.
    ...resolveWebFetchTools(),
    // Google read-only (Calendar/Gmail/Drive) — conector OAuth vira tool de agente.
    // Fora do browser → []. O refresh do token acontece no Worker (googleToken.js).
    ...resolveGoogleTools(),
    // GitHub read-only — os projetos do usuário viram contexto de conversa (agente E voz).
    ...resolveGithubTools(),
    // DeerFlow borrow #2 — playbook de skill grande carrega sob demanda (header no prompt).
    ...resolveLoadSkillTools(),
    // Pedro 2026-08 — integrações MCP como tools de agente nas DUAS surfaces (Code E
    // Chat): servidores MCP conectados (apolo-memory hoje) viram mcp__{server}__{tool}.
    // Fora do Electron ⇒ [] ⇒ tool set byte-idêntico.
    ...(await resolveMcpConnectorTools()),
  ];
}
